export default __webpack_public_path__ + "static/media/footer-w.88b0e3cd.png";